import React from 'react'
import './title.css'

function Title() {
  return (
    <div className='title-container'>
        <h1 className='title-header'>Personal Photo Gallery</h1>
        <h2>Your Picture</h2>
        <p>Please upload your file and see how it work !</p>
    </div>
  )
}

export default  Title